module.exports = __webpack_public_path__ + "media/app/containers/PendingApprovalPage/Edit.e9a059a9.svg";